import { uri } from '../../api-endpoint';
import { ILabelFromAPISuccessResponse } from '../../type-conversion/label/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchModelLabelListAPI = (token: string) => (modelId: number) =>
  fetchListTemplateFn(
    token,
    uri.modelLabelList(modelId),
    ILabelFromAPISuccessResponse
  );
